import { render } from "./CustomsDeclarationForm.vue?vue&type=template&id=17806d0c&scoped=true"
import script from "./CustomsDeclarationForm.vue?vue&type=script&lang=js"
export * from "./CustomsDeclarationForm.vue?vue&type=script&lang=js"

import "./CustomsDeclarationForm.vue?vue&type=style&index=0&id=17806d0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17806d0c"]])

export default __exports__